import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useQuizTopics(data = {}) {
  const { enabled = false, queryParams = '', quizID, topicID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getQuizDetails() {
    return privateFetch
      .get(`/v1/admin/topic/${topicID}/quiz/${quizID}${queryParams}`)
      .then((res) => res.data);
  }

  return useQuery(['quiz-details', quizID, { data }], getQuizDetails, { enabled });
}

export default useQuizTopics;
